import axios from './ajax.js'
import router from '../router'
import store from '../store';
import commonUtil from '@/assets/common'
import qs from "qs";
import {
    Toast,
    Dialog
} from 'vant';
import {DETAIL as API} from "@/assets/api";

const commonService = {
    //获取车场信息（套餐充值相关）
    getParkingList(carNum){
        let req = {
            vehicleno:carNum,
            originalId:sessionStorage.getItem("originalId")
        }
        axios({
            method: 'post',
            url: API.QUERY_SETMEAL_BY_VEHICLE,
            data: req,
            success: function(data){
                if(data.code == 0){
                    store.state.dataObj = data.data;
                }else{
                    store.state.dataObj = data;
                }
            },
            error:function(){

            }
        })
    }
};

export default  commonService;



// WEBPACK FOOTER //
// ./src/assets/commonService.js